module.exports = __webpack_public_path__ + "static/podcast5-634840b3de195a9c1b9cd73c75015a49.jpg";